import { Component, OnInit } from '@angular/core';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { WorkflowTemplate } from 'app/models/workflow-template';
import { UserService } from 'app/services/user.service';
import { MDBModalService } from 'ng-uikit-pro-standard';
import { FeatureTrialLockModalComponent } from 'app/views/feature-trial-lock-modal/feature-trial-lock-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-workflow-templates',
  templateUrl: './workflow-templates.component.html',
  styleUrls: ['./workflow-templates.component.scss']
})
export class WorkflowTemplatesComponent implements OnInit {
  workflowsTemplates: WorkflowTemplate[] = [];
  filteredTemplates: WorkflowTemplate[] = [];
  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedTableLimit = 5;
  tableLoadingIndicator: boolean = false;
  searchKey: string = "";
  constructor(private workflowTemplatesService: WorkflowTemplateService, private userService: UserService,
            private modalService: MDBModalService, private router: Router) { }

  ngOnInit() {
    this.getTemplates();
  }

  getTemplates(){
    this.tableLoadingIndicator = true;
    this.workflowTemplatesService.getAll(false, true).subscribe(res => {
      if(res){
        this.workflowsTemplates = res;
        this.filteredTemplates = res;
      }
      this.tableLoadingIndicator = false;
    })
  }

  searchTemplates(val){
    this.filteredTemplates = this.workflowsTemplates.filter(templates => {
      return (templates.name.toLowerCase().indexOf(val) !== -1 || (templates.description && templates.description.toLowerCase().indexOf(val) !== -1) || !val)
    })
  }

  innerWidth() {
    return window.innerWidth;
  }

  checkTrialAndStartWorkflow(workflowId: number) {
    if (!this.userService.currentUserValue.subscription_status.is_subscribed &&
      !this.userService.currentUserValue.subscription_status.trial_active) {
        this.modalService.show(FeatureTrialLockModalComponent, {
          ignoreBackdropClick: true,
          backdrop: false,
          animated: true,
          containerClass: 'modal fade',
          class: 'modal-dialog modal-danger modal-notify',
          data: {
          }
        });
    } else {
      this.router.navigate(['/workflows/start-new/'+ workflowId +'/initial-submission']);
    }
  }
}
